exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-inline .btn-ha[data-v-42da94b6] {\n  display: inline-block;\n}\n.game-participant img[data-v-42da94b6] {\n  height: 20px;\n}\n.user-profile-rank-stats .stats-item[data-v-42da94b6] {\n  margin-top: 0;\n  height: auto !important;\n}\n.stats-item[data-v-42da94b6] {\n  position: relative;\n}\n.detailed-rating[data-v-42da94b6] {\n  font-size: 0.8em !important;\n  position: absolute;\n  margin-top: -0.75em !important;\n  left: 50%;\n  width: 150%;\n  transform: translateX(-50%);\n  cursor: help;\n}\n.challenge-first-cell[data-v-42da94b6] {\n  max-width: 10em;\n}\n", ""]);

// exports
